/**
 * Two-factor reminder for administrators (P1-16, Paul's ruling 4 Nov 2026:
 * "Warn now, enforce later").
 *
 * Presentation only. Dismissing the reminder never satisfies MFA and never
 * changes access. A dismissal lasts for the browser session only: the cookie
 * below carries no Max-Age, so the reminder returns in the next session until
 * the administrator has a verified factor.
 *
 * The cookie name changed from `statura-mfa-reminder-<id>` (a one-year
 * "dismiss for good" cookie) so that earlier permanent dismissals no longer
 * silence the reminder.
 */
export function mfaReminderDismissalCookie(userId: string): string {
  return `statura-mfa-reminder-session-${encodeURIComponent(userId)}`;
}

/** sessionStorage key mirroring the session cookie for client-side reads. */
export function mfaReminderSessionStorageKey(userId: string): string {
  return `statura:mfa-reminder-dismissed-session:${userId}`;
}

/** The established administrator enrolment flow, returning to where the admin was. */
export function mfaReminderEnrolHref(currentPath: string | null | undefined): string {
  const path =
    typeof currentPath === 'string' && currentPath.startsWith('/') && !currentPath.startsWith('//')
      ? currentPath
      : '/';
  if (path === '/' || path.startsWith('/auth/')) return '/auth/mfa/enroll';
  return `/auth/mfa/enroll?next=${encodeURIComponent(path)}`;
}

export type MfaReminderSeed = {
  userId: string;
  needsMfa: boolean;
  dismissed: boolean;
  hostSuppressed: boolean;
};
